<div class="app-page">
  <!-- Header -->
  <div class="app-page-header">
    <div class="flex items-center justify-between">
      <div>
        <h1 class="section-title">{{ isNew ? 'Nuevo Material' : 'Editar Material' }}</h1>
        <p class="section-subtitle">
          {{ isNew ? 'Completa los datos para crear un nuevo material' : 'Modifica la información del material' }}
        </p>
      </div>
      <div class="flex gap-2">
        <button 
          pButton 
          type="button"
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-outlined"
          (click)="cancelar()"
          [disabled]="loading()">
        </button>
        <button 
          pButton 
          type="button"
          [label]="isNew ? 'Crear Material' : 'Guardar Cambios'"
          [icon]="isNew ? 'pi pi-plus' : 'pi pi-check'"
          class="p-button"
          (click)="guardar()"
          [disabled]="loading() || form.invalid"
          [loading]="loading()">
        </button>
      </div>
    </div>
  </div>

  <!-- Main Content -->
  <div class="app-page-content edit-layout">
    <p-toast></p-toast>

    <form [formGroup]="form" (ngSubmit)="guardar()" id="materialForm" class="edit-form">
      <div class="app-card">
        <!-- Form Title -->
        <h2 class="text-xl font-semibold mb-2" style="color: hsl(var(--text));">
          {{ isNew ? 'Datos Generales' : 'Datos del Material' }}
        </h2>

        <div class="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 mt-6">
          <!-- Código -->
          <div class="space-y-2">
            <label for="codigo" class="text-sm font-medium" style="color: hsl(var(--text));">
              Código *
            </label>
            <input 
              pInputText 
              id="codigo" 
              formControlName="codigo"
              type="text"
              placeholder="MAT-001"
              class="w-full"
              [class.border-red-500]="form.get('codigo')?.invalid && form.get('codigo')?.touched"
            />
            @if (form.get('codigo')?.invalid && form.get('codigo')?.touched) {
              <small class="text-sm block" style="color: hsl(var(--danger));">
                El código es requerido y debe tener máximo 255 caracteres
              </small>
            }
          </div>

          <!-- Nombre -->
          <div class="space-y-2">
            <label for="nombre" class="text-sm font-medium" style="color: hsl(var(--text));">
              Nombre *
            </label>
            <input 
              pInputText 
              id="nombre" 
              formControlName="nombre"
              type="text"
              placeholder="Material Premium"
              class="w-full"
              [class.border-red-500]="form.get('nombre')?.invalid && form.get('nombre')?.touched"
            />
            @if (form.get('nombre')?.invalid && form.get('nombre')?.touched) {
              <small class="text-sm block" style="color: hsl(var(--danger));">
                El nombre es requerido y debe tener máximo 255 caracteres
              </small>
            }
          </div>

          <!-- Descripción -->
          <div class="space-y-2">
            <label for="descripcion" class="text-sm font-medium" style="color: hsl(var(--text));">
              Descripción
            </label>
            <textarea 
              pInputTextarea 
              id="descripcion" 
              formControlName="descripcion"
              placeholder="Descripción del material"
              rows="2"
              class="w-full">
            </textarea>
          </div>

          <!-- Frecuencia -->
          <div class="space-y-2">
            <label for="frecuencia" class="text-sm font-medium" style="color: hsl(var(--text));">
              Frecuencia *
            </label>
            <p-autoComplete
              id="frecuencia"
              formControlName="frecuencia"
              [suggestions]="frecuencias"
              optionLabel="label"
              optionValue="value"
              placeholder="Seleccionar frecuencia..."
              [showEmptyMessage]="true"
              emptyMessage="No hay opciones disponibles"
              class="w-full"
              [dropdown]="true"
              [forceSelection]="true"
              [class.border-red-500]="form.get('frecuencia')?.invalid && form.get('frecuencia')?.touched"
            ></p-autoComplete>
            @if (form.get('frecuencia')?.invalid && form.get('frecuencia')?.touched) {
              <small class="text-sm block" style="color: hsl(var(--danger));">
                La frecuencia es requerida
              </small>
            }
          </div>

          <!-- Costo del Segundo -->
          <div class="space-y-2">
            <label for="costoDelSegundo" class="text-sm font-medium" style="color: hsl(var(--text));">
              Costo por Segundo *
            </label>
            <p-inputNumber
              id="costoDelSegundo"
              formControlName="costoDelSegundo"
              [mode]="'decimal'"
              [minFractionDigits]="2"
              [maxFractionDigits]="4"
              placeholder="0.00"
              class="w-full"
              [class.border-red-500]="form.get('costoDelSegundo')?.invalid && form.get('costoDelSegundo')?.touched"
            ></p-inputNumber>
            @if (form.get('costoDelSegundo')?.invalid && form.get('costoDelSegundo')?.touched) {
              <small class="text-sm block" style="color: hsl(var(--danger));">
                El costo es requerido y debe ser mayor a 0
              </small>
            }
          </div>

          <!-- Duración (segundos) -->
          <div class="space-y-2">
            <label for="duracion" class="text-sm font-medium" style="color: hsl(var(--text));">
              Duración (segundos)
            </label>
            <p-inputNumber
              id="duracion"
              formControlName="duracion"
              [min]="0"
              [maxFractionDigits]="0"
              placeholder="Ej. 10, 20, 30"
              class="w-full"
              [class.border-red-500]="form.get('duracion')?.invalid && form.get('duracion')?.touched"
            ></p-inputNumber>
            <small class="text-sm block" style="color: hsl(var(--muted));">
              Duración del material (ej. spot 10s, 20s). Usado como valor por defecto al elegir material en ítems Aire Spot.
            </small>
            @if (form.get('duracion')?.invalid && form.get('duracion')?.touched) {
              <small class="text-sm block" style="color: hsl(var(--danger));">
                Debe ser &ge; 0
              </small>
            }
          </div>

          <!-- Rubro -->
          <div class="space-y-2">
            <label for="rubro" class="text-sm font-medium" style="color: hsl(var(--text));">
              Rubro *
            </label>
            <p-autoComplete
              id="rubro"
              formControlName="rubro"
              [suggestions]="rubrosFiltrados()"
              (completeMethod)="filtrarRubros($event)"
              optionLabel="nombre"
              optionValue="value"
              placeholder="Buscar rubro..."
              [showEmptyMessage]="true"
              emptyMessage="No hay rubros disponibles"
              class="w-full"
              [dropdown]="true"
              [forceSelection]="true"
              [showClear]="true"
              [class.border-red-500]="form.get('rubro')?.invalid && form.get('rubro')?.touched"
            ></p-autoComplete>
            @if (form.get('rubro')?.invalid && form.get('rubro')?.touched) {
              <small class="text-sm block" style="color: hsl(var(--danger));">
                El rubro es requerido
              </small>
            }
          </div>

          <!-- Tipo de Material -->
          <div class="space-y-2">
            <label for="tipoMaterial" class="text-sm font-medium" style="color: hsl(var(--text));">
              Tipo de Material *
            </label>
            <p-autoComplete
              id="tipoMaterial"
              formControlName="tipoMaterial"
              [suggestions]="tiposMaterialFiltrados()"
              (completeMethod)="filtrarTiposMaterial($event)"
              optionLabel="nombre"
              optionValue="value"
              placeholder="Buscar tipo de material..."
              [showEmptyMessage]="true"
              emptyMessage="No hay tipos disponibles"
              class="w-full"
              [dropdown]="true"
              [forceSelection]="true"
              [showClear]="true"
              [class.border-red-500]="form.get('tipoMaterial')?.invalid && form.get('tipoMaterial')?.touched"
            ></p-autoComplete>
            @if (form.get('tipoMaterial')?.invalid && form.get('tipoMaterial')?.touched) {
              <small class="text-sm block" style="color: hsl(var(--danger));">
                El tipo de material es requerido
              </small>
            }
          </div>

          <!-- Tarifa -->
          <div class="space-y-2">
            <label for="tarifa" class="text-sm font-medium" style="color: hsl(var(--text));">
              Tarifa *
            </label>
            <p-autoComplete
              id="tarifa"
              formControlName="tarifa"
              [suggestions]="tarifasFiltradas()"
              (completeMethod)="filtrarTarifas($event)"
              optionLabel="nombre"
              optionValue="value"
              placeholder="Buscar tarifa..."
              [showEmptyMessage]="true"
              emptyMessage="No hay tarifas disponibles"
              class="w-full"
              [dropdown]="true"
              [forceSelection]="true"
              [showClear]="true"
              [class.border-red-500]="form.get('tarifa')?.invalid && form.get('tarifa')?.touched"
            ></p-autoComplete>
            @if (form.get('tarifa')?.invalid && form.get('tarifa')?.touched) {
              <small class="text-sm block" style="color: hsl(var(--danger));">
                La tarifa es requerida
              </small>
            }
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

